const OIDC_AUTHORITY = process.env.VUE_APP_OIDC_AUTHORITY
const IMS_BASE_URL = process.env.VUE_APP_IMS_BASE_URL
const SOLAR_URL = process.env.VUE_APP_SOLAR_URL
const OCEAN_URL = process.env.VUE_APP_OCEAN_URL

export { OIDC_AUTHORITY, IMS_BASE_URL, SOLAR_URL, OCEAN_URL }
